export const ATTENDEE = `
	query attendee($id: Uint) {
		attendee(id: $id) {
			id
			email
			token
			push_token
			sso_id
			first_name
			last_name
			password
			company
			bio
			address
			city
			county
			country
			state
			postal_code
			avatar_url
			mobile_number
			phone_number
			facebook_url
			linkedin_url
			website_url
			twitter_url
			blog_url
			is_manager
			client_metadata
			events {
				id
				name
			}
			groups {
				id
				name
			}
			last_sync
			last_login
			created_at
			updated_at
			deleted_at
			auth_histories {
				id
				device_uniq_id
				device_manufacturer
				device_model
				device_id
				device_os
				device_os_version
				app_bundle_id
				app_version
				app_build_version
				login_ip_address
				sync_date
			}
		}
	}
`;

export const CLIENT_ATTENDEES = `
	query clientAttendees(
		$client_id: Uint
		$search_term: String
		$offset: Uint
		$items_per_page: Uint
	) {
		clientAttendees(
			client_id: $client_id
			search_term: $search_term
			offset: $offset
			items_per_page: $items_per_page
		) {
			nodes {
				id
				email
				first_name
				last_name
				company
				phone_number
				is_manager
				updated_at
				push_tokens {
					token
				}
			}
			page_info {
				has_next_page
				total_count
			}
		}
	}
`;

export const EVENT_ATTENDEES = `
	query eventAttendees(
		$client_id: Uint
		$event_id: Uint
		$search_term: String
		$offset: Uint
		$items_per_page: Uint
	) {
		eventAttendees(
			client_id: $client_id
			event_id: $event_id
			search_term: $search_term
			offset: $offset
			items_per_page: $items_per_page
		) {
			nodes {
				id
				email
				first_name
				last_name
				avatar_url
				company
				title
				phone_number
				is_manager
				updated_at
				push_tokens {
					token
				}
				total_points
			}

			page_info {
				has_next_page
				total_count
			}
		}
	}
`;

export const EVENT_ATTENDEE_LIMITED = `
	query attendee($id: Uint) {
		attendee(id: $id) {
			id
			email
			first_name
			last_name
			company
			title
			phone_number
			is_manager
			updated_at
			push_tokens {
				token
			}
			total_points
		}
	}
`;

export const ATTENDEE_AGENDA = `
	query attendeeAgenda($event_id: Uint, $attendee_id: Uint) {
		attendeeAgenda(event_id: $event_id, attendee_id: $attendee_id) {
			id
			name
			description
			location
			link
			notes
			agenda_color
			start_time
			end_time
			recurring
			recurring_type
			groups {
				id
				name
			}
		}
	}
`;

export const EVENT_ATTENDEE_METADATA = `
	query eventAttendeeMetadata($id: Uint, $event_id: Uint) {
		eventAttendeeMetadata(id: $id, event_id: $event_id) {
			metadata
			custom_metadata_fields
			custom_metadata_attributes {
				key
				name
				category
			}
		}
	}
`;

export const TOKENS = `
	query pushAnnouncementTokens($attendee_id: Uint) {
		pushAnnouncementTokens(attendee_id: $attendee_id) {
			token
		}
	}
`;
